/**
 * 公共接口
 * Filename: sys.js
 * Author: GaoYu
 * Time: 2020/7/15 13:31
 */

import request from '@/utils/request'

export function smsCodeApi (data) {
  return request({
    url: process.env.API_DY_BASE_URL + 'user/v1/sms/code',
    method: 'post',
    data
  })
}

export function loginOrRegApi (data) {
  return request({
    url: process.env.API_DY_BASE_URL + 'user/v1/signInOrReg',
    method: 'post',
    data
  })
}

export function getWechatInfoByCodeApi (params) {
  return request({
    url: process.env.API_DY_BASE_URL + 'user/v1/wechat/info',
    method: 'get',
    params
  })
}

export function bindWecahtApi (data) {
  return request({
    url: process.env.API_DY_BASE_URL + 'user/v1/bindWechat',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/sys.js